import { useNavigate } from "react-router-dom";
import {
  useGetAdventuresQuery,
  useGetDestinationsWithImageQuery,
  useGetProgrammesQuery,
} from "../../apiCaller/apis/getApi";
import { GetTableListAPI } from "../../apiCaller/getAPIsCaller";
import { MdOutlineCalendarMonth } from "react-icons/md";

import ClientLayout from "../../components/Layout/ClientLayout";
import SearchBarComponent from "../../components/searchBar/SearchBarComponent";
import NoImage from "../../assets/images/No_Image_Available.jpg";
import HtmlContent from "../../utils/DisplayHTML";
import DateFormatterComponent from "../../utils/DateFormatterComponent";
import ButtonComponent from "../../components/button/Button";
import { useState } from "react";
import SpinningLoader from "../../components/SpinningLoader/SpinningLoader";
import PaginationComponent from "../../components/pagination";
import ProgrammeSearchBarComponent from "../../components/searchBar/ProgrammeSearchBarComponent";
const ProgrammeList = () => {
  const [search, setSearch] = useState({page:1, totalItems: 5 });
  const {
    data: programmes,
    error: programmeError,
    isLoading: programmeIsLoading,
    isFetching: programmeIsFetching,
  } = GetTableListAPI(search, useGetProgrammesQuery);

  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/programmes/${id}`);
  };

  const handlePageClick = (page) => {
    const newSearch = { ...search, page: page + 1 };
    setSearch(newSearch);
  };

  const handleSearch = (params) => {
    // console.log(params)
    const newSearch = { ...search, ...params };
    setSearch(newSearch);
  };

  return (
    <ClientLayout>
      <div className="px-5">
        {/* HERO COMPONENT */}
        <div className="bg-programme-image h-[400px] bg-cover  rounded-lg relative w-full">
          <div class="absolute inset-0 bg-color-primary-dark2 opacity-20"></div>
          <div className="text-5xl font-bold text-white z-100 flex justify-center items-center h-full">
            Our Programs
          </div>
        </div>

        {/* SEARCH COMPONENT */}
        <div className="px-10 md:px-16 lg:px-48 py-10 w-full">
          <div className="">
            <ProgrammeSearchBarComponent handleSearch={handleSearch} />
          </div>

          {/* DESTINATION LIST */}
          {programmeIsLoading || programmeIsFetching ? (
            <SpinningLoader isLoading={true} hasData={false} />
          ) : (
            <div className="my-10 w-full">
              {programmes?.results.map((programme, index) => (
                <div
                  key={index}
                  className="flex flex-col md:flex-row items-start md:items-center space-y-5 md:space-y-0 md:space-x-10 my-5 border-b border-gray-200 pb-8"
                >
                  {/* Image Section */}
                  <div className="w-full md:w-1/4">
                    <img
                      src={programme?.displayImage}
                      className="h-auto w-full rounded-lg object-cover"
                      alt={programme?.name}
                    />
                  </div>

                  {/* Content Section */}
                  <div className="flex-1 flex flex-col space-y-5">
                    <div className="font-semibold text-2xl md:text-4xl">
                      {programme?.name}
                    </div>

                    <div>
                      <HtmlContent htmlData={programme?.description} />
                    </div>

                    {/* Dates */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-10 space-y-3 sm:space-y-0">
                      <div className="flex items-center space-x-2">
                        <MdOutlineCalendarMonth />
                        <div className="font-semibold">
                          Start Date:{" "}
                          <DateFormatterComponent date={programme?.startDate} />
                        </div>
                      </div>

                      <div className="flex items-center space-x-2">
                        <MdOutlineCalendarMonth />
                        <div className="font-semibold">
                          End Date:{" "}
                          <DateFormatterComponent date={programme?.endDate} />
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-8">
                      <a
                        target="_blank"
                        href={programme?.bookingLink}
                        rel="noopener noreferrer"
                      >
                        <ButtonComponent name="Book Now" type="book" />
                      </a>
                      <div onClick={() => handleClick(programme?.id)}>
                        <ButtonComponent
                          name="Learn More"
                          type="book"
                          className="bg-gray-500 border-gray-300"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div>
            <PaginationComponent
              pageCount={programmes?.totalPages}
              totalItems={programmes?.totalItems}
              handlePageClick={handlePageClick}
            />
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default ProgrammeList;
